import Home from './components/home';
import Quote from './components/quote';
import NavBar from './components/navbar';
import Footer from './components/footer';
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './components/about';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <ScrollToTop />
        <NavBar />
        <Routes>
          <Route path='/'  element={<Home/>}/>
          <Route path='/about' element={<About/>} />
          <Route path='/quote' element={<Quote/>} />
        </Routes>
        <Footer />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
